export const LOCAL_STORAGE_APP_STATE_KEY = 'fedimint_ui_state_v2';
export const LATEST_RELEASE_TAG = 'v0.5.1';
